export default {
    accounts: {
        ALAVA: 'Diputación Foral Alava',
        CONJUNTA: 'Conjunta',
        ENVIADO: 'Enviada',
        EXENTO: 'Exento',
        EXTRANJERO: 'Extranjero',
        F: 'Persona física',
        FINALIZED: 'Finalizado',
        GENERAL: 'General',
        GUIPUZCOA: 'Diputación Foral Guipuzcoa',
        INDISTINTA: 'Indistinta',
        J: 'Persona jurídica',
        MANCOMUNADA_CONDICIONADA: 'Mancomunada condicional',
        MANCOMUNADA: 'Mancomunada',
        NAVARRA: 'Diputación Foral Navara',
        RD_SENT: 'Enviada',
        REGISTERED_EMAIL: 'Alta email',
        REGISTERED_ONLINE: 'Alta online',
        REGISTERED_POSTAL: 'Alta postal',
        REGISTERED: 'Alta',
        SIGNED: 'Firmado',
        SOLIDARIA: 'Solidaria',
        VALIDADO: 'Validada',
        VALIDATED: 'Validada',
        VIZCAYA: 'Diputación Foral Vizcaya'
    },
    interveners: {
        AD: 'Administrador',
        ADMINISTRADOR: 'Administrador',
        AG: 'Gestora',
        AI: 'Titular Real',
        ANNUAL: 'Anual',
        AP: 'Apoderado',
        APODERADO: 'Apoderado',
        APORTANTE_CONYUGE: 'Aportante cónyuge',
        APORTANTE_FAMILIAR: 'Aportante familiar',
        APORTANTE: 'Aportante',
        AR: 'Representante Legal',
        AS: 'Asesor',
        ASESOR: 'Asesor',
        AU: 'Autorizado',
        AUTORIZADO_CONSULTA: 'Autorizado Consultivo',
        AUTORIZADO: 'Autorizado Operativo',
        BARE_OWNERSHIP: 'Nudo propietario',
        BENEFICIARIO: 'Beneficiario',
        BLOQUEADO_AML: 'Bloqueado por AML',
        BLOQUEADO: 'Bloqueado',
        CEDULA_IDENTIFICACION: 'Celula identificación',
        CIF: 'CIF',
        DNI: 'DNI',
        EMAIL: 'Correo electrónico',
        ENVIADO: 'Enviado',
        F: 'Persona física',
        FIDUCIARIO: 'Fiduciario',
        FIDUCIARY: 'Fiduciario',
        FINALIZADO: 'Finalizado',
        FINALIZED: 'Finalizado',
        GESTOR: 'Gestora',
        H: 'Femenino',
        J: 'Persona jurídica',
        JUNTA_DIRECTIVA: 'Junta directiva',
        JURIDICA_EXTRANGERA: 'Jurídica extranjera',
        MONTHLY: 'Mensual',
        NIE: 'NIE',
        NIF: 'NIF',
        NOT_SEND: 'No enviar',
        NUDO_PROPIETARIO: 'Nudo propietario',
        OTROS: 'Otros',
        PARTICIPE: 'Participe',
        PASAPORTE: 'Pasaporte',
        PATRONO: 'Patrono', // TODO: Eliminar cuando se pueda
        POSTAL: 'Dirección postal',
        QUARTERLY: 'Trimestral',
        REGISTERED_EMAIL: 'Alta email',
        REGISTERED_ONLINE: 'Alta online',
        REGISTERED_POSTAL: 'Alta postal',
        REGISTERED: 'Alta',
        REPRESENTANTE_LEGAL: 'Representante legal',
        SEMIANNUAL: 'Semestral',
        SEND: 'Enviar',
        SHAREHOLDER: 'Participe',
        SIGNED: 'Firmado',
        TARJETA_RESIDENTE: 'Tarjeta de residente',
        TITULAR_REAL: 'Titular real', // TODO: Eliminar cuando se pueda
        TITULAR: 'Titular',
        TUTOR: 'Tutor',
        USUFRUCTUARIO: 'Usufructuario',
        V: 'Masculino',
        VALIDADO: 'Validado',
        VALIDATED: 'Validado'
    },
    issues: {
        'in-progress': 'En curso',
        'IN-PROGRESS': 'En curso',
        ACCOUNT: 'Cuenta',
        ACTIVE: 'Activo',
        ADMINISTRATION: 'Administración',
        BLOCKED: 'Bloqueado',
        CASH_FLOW: 'Efectivo',
        COMPLIANCE: 'Conformidad',
        DOCUMENTATION: 'Documentación',
        ENVIADO: 'Enviado',
        FINALIZADO: 'Finalizado',
        INTERVENER_CARE: 'Relación con inversores',
        INTERVENER: 'Interviniente',
        LEGAL: 'Legal',
        open: 'Pendiente',
        OPEN: 'Pendiente',
        OPERATION: 'Operación',
        PENDIENTE: 'Pendiente',
        PENDING: 'Pendiente',
        RD_SENT: 'Enviado',
        resolved: 'Resuelta',
        RESOLVED: 'Resuelta',
        VALIDADO: 'Validado',
        VALIDATED: 'Validado'
    },
    operations: {
        '1': 'Anteriores a 2007',
        '2': 'Posteriores a 2007',
        '3': 'De ambos',
        'no-increase': 'Sin incremento',
        A: 'Ambos',
        ACUMULATIVO: 'Acumulativo',
        ADELANTO_COBRO: 'Adelanto del cobro de capital',
        ANUAL: 'Anual',
        APORTACION_PERIODICA: 'Aportación Periódica',
        APORTACION: 'Aportación',
        B: 'Importe bruto',
        BENEFICIARIO: 'Beneficiario - derechos económicos',
        BLOQUEO_PARTICIPACIONES: 'Bloqueo de participaciones',
        C: 'Derechos consolidados',
        CANCELLED: 'Anulada',
        CHEQUE: 'Cheque',
        CONTINGENCIA_ENTRADA: 'Entrada de Saldo por Contingencia',
        CONTINGENCIA_SALIDA: 'Salida de Saldo por Contingencia',
        COMPRESION: 'Compresión',
        DEPENDENCIA: 'Dependencia',
        DESBLOQUEO_PARTICIPACIONES: 'Desbloqueo de participaciones',
        DESEMPLEO: 'Desempleo',
        DIFERIDO: 'Diferido',
        DISMINUCION_RENTA: 'Disminución de la renta',
        DIVIDENDO: 'Dividendo',
        DOMICILIACION: 'Domiciliación',
        DONACION_ENTRADA: 'Donación de Entrada',
        DONACION_SALIDA: 'Donación de Salida',
        E: 'Derechos económicos',
        ENFERMEDAD_GRAVE: 'Enfermedad grave',
        FALLECIMIENTO: 'Fallecimiento',
        FINALIZED: 'Finalizada',
        FINANCIERA: 'Renta financiera',
        HERENCIA_ENTRADA: 'Herencia de Entrada',
        HERENCIA_SALIDA: 'Herencia de Salida',
        I: 'Importe neto',
        INCREMENTO_RENTA: 'Incremento de la renta',
        INVALIDEZ: 'Invalidez',
        JUBILACION: 'Jubilación',
        LINEAL: 'Lineal',
        MENSUAL: 'Mensual',
        MIXTA: 'Renta Mixta',
        NO_DIFERIDO: 'No diferido',
        OMF: 'OMF',
        OTRAS: 'Otras',
        P: 'Participaciones',
        PARTICIPE: 'Participe - derechos consolidados',
        PERIODIC_ACTIVE: 'Periódica Activa',
        PERIODIC_SUSPENDED: 'Periódica suspendida',
        PORCENTUAL: 'Porcentual',
        RD_SENT: 'Enviada',
        REEMBOLSO_PARTICIPACIONES: 'Reembolso de participaciones',
        REEMBOLSO_PERIODICO: 'Reembolso Periódico',
        REEMBOLSO: 'Reembolso',
        REGISTERED_EMAIL: 'Pendiente',
        REGISTERED_ONLINE: 'Pendiente',
        REGISTERED_POSTAL: 'Pendiente',
        REGISTERED: 'Pendiente',
        RESCATE: 'Rescate',
        SEMESTRAL: 'Semestral',
        SIGNED: 'Firmado',
        SNCE_1: 'SNCE 1',
        SNCE_2: 'SNCE 2',
        SNCE_3: 'SNCE 3',
        SOLICITUD_APORTACION_PERIODICA: 'Solicitud de Aportación Periódica',
        SOLICITUD_REEMBOLSO_PERIODICO: 'Solicitud de Reembolso Periódico',
        SOLICITUD_REEMBOLSO: 'Solicitud de Reembolso',
        SOLICITUD_SUSCRIPCION_PERIODICA: 'Solicitud de Suscripción Periódica',
        SOLICITUD_SUSCRIPCION: 'Solicitud de Suscripción',
        SOLICITUD_TRASPASO_EXTERNO_ENTRADA: 'Solicitud Traspaso Externo de Entrada',
        SOLICITUD_TRASPASO_EXTERNO_SALIDA: 'Solicitud Traspaso Externo de Salida',
        SOLICITUD_TRASPASO_INTERNO: 'Solicitud Traspaso Interno',
        SPLIT: 'Split',
        SUSCRIPCION_PARTICIPACIONES: 'Suscripción de participaciones',
        SUSCRIPCION_PERIODICA: 'Suscripción Periódica',
        SUSCRIPCION: 'Suscripción',
        TOTAL: 'Totalidad del capital',
        TRANSFERENCIA: 'Transferencia',
        TRASPASO_ENTRADA: 'Traspaso de Entrada',
        TRASPASO_SALIDA: 'Traspaso de Salida',
        TRIMESTRAL: 'Trimestral',
        VALIDATED: 'Validada',
        VARIACION_PRESTACION: 'Variación prestación',
        DEVOLUCION_EXCESO: 'Devolución de exceso',
        key_sub_operation_type: {
            TC: 'Traspaso de clase',
            B: 'Bloqueo Manual',
            P: 'Pignoración | Herencia Pago Gananciales | Prestación',
            I: 'Traspaso Interno',
            E: 'Traspaso Externo',
            S: 'Canje',
            R: 'Separación de bienes',
            C: 'Capitulación',
            T: 'Cambio Titularidad',
            O: 'Cambio Comercializador | Otros',
            N: 'Testamentaría',
            D: 'Disolución',
            L: 'Disolución Sociedad Gananciales',
            F: 'Fusión',
            H: 'Herencia',
            G: 'Renta Obligatoria',
            V: 'Prestaciones con Reversión',
            A: 'Actuarial',
            J: 'Baja',
            AP: 'Aportación con Prestación'
        },
        ind_percepcion_pres: {
            C: 'Capital',
            R: 'Renta',
            M: 'Mixto',
            O: 'Otros'
        },
        ind_tipo_pres: {
            C: 'Capital Inmediato',
            D: 'Capital Diferido',
            A: 'Renta Asegurada Inmediata',
            R: 'Renta Asegurada Diferida',
            F: 'Renta Financiera Inmediata',
            N: 'Renta Financiera Diferida',
            V: 'Renta Vitalicia'
        }

    },
    permissions: {
        ACCOUNTS: 'Cuentas',
        BLOCK_INTERVENER_AML: 'Bloquear interviniente por AML',
        DISTRIBUTORS: 'Distribuidores',
        DOCUMENT_VALIDATION: 'Validar documentacion',
        GROUPS: 'Grupos',
        IMPORT: 'Importación',
        INTERVENERS: 'Intervinientes',
        ISSUES: 'Casos',
        MANAGE_PRIVATE_OPERATIONS: 'Tratar operaciones privadas',
        MARK_CUSTOMER_AS_VIP: 'Marcar un cliente como VIP',
        OPERATIONS: 'Operaciones',
        PERMISSION_SETS: 'Permission sets',
        RECONCILIATION: 'Conciliación',
        SUBDISTRIBUTORS: 'Subdistribuidores',
        USERS: 'Usuarios',
        VALIDATE_CUSTOMERS: 'Validar clientes'
    }
};
